<div class="container">
  <div class="progress-container col-10">
    <div class="progress" #progress></div>
    <div
      class="circle"
      *ngFor="let step of steps; let i = index"
      [class.active]="i + 1 === currentActive"
      [class.completed]="i + 1 < currentActive"
    >
    <ng-container *ngIf="i + 1 < currentActive">
      <svg  xmlns="http://www.w3.org/2000/svg" width="15.506" height="14" viewBox="0 0 15.506 14">
        <path id="Path_1487" data-name="Path 1487" d="M15.145,72.24a1.063,1.063,0,0,0-1.739,0L5.578,82.062,2.1,77.7a1.063,1.063,0,0,0-1.739,0,1.833,1.833,0,0,0,0,2.183l4.349,5.456a1.063,1.063,0,0,0,1.739,0l8.7-10.913A1.833,1.833,0,0,0,15.145,72.24Z" transform="translate(0.001 -71.788)" fill="#fff"/>
      </svg>
    </ng-container>
    <ng-container>
      <div class="label primary-text text-light-gray text-nowrap">{{ step }}</div>
    </ng-container>
    </div>
  </div>
</div>
<div>
  <ng-content select="app-progress-step"></ng-content>
</div>

<div class="button-container d-none">
  <button class="btn" (click)="onPrevClick()" [disabled]="currentActive === 1">Prev</button>
  <button class="btn" (click)="onNextClick()">Next</button>
  <!-- [disabled]="currentActive === steps.length" -->
</div>
